import SolvedIcon from './component'

export default SolvedIcon
